/*
 * Product add-ons (snippets/product-addons.liquid)
 *
 * Ticked add-ons are added to the cart (quantity 1 each) once the main product has been added.
 * When the "Choose Your Pot" script (variant-addons.js) is on the page, it calls ProductAddons.addWithExtras()
 * so the pot and the add-ons go in a single request. Otherwise this script adds them on its own.
 */
(function() {
  if (window.ProductAddons) return;

  function getContainers(formId) {
    return document.querySelectorAll(`.product-addons[data-form="${formId}"]`);
  }

  function getItems(formId) {
    var items = [];
    getContainers(formId).forEach(function(container) {
      container.querySelectorAll('input[data-product-addon]:checked').forEach(function(input) {
        items.push({ id: input.value, quantity: 1 });
      });
    });
    return items;
  }

  function clear(formId) {
    getContainers(formId).forEach(function(container) {
      container.querySelectorAll('input[data-product-addon]:checked').forEach(function(input) {
        input.checked = false;
      });
    });
  }

  function postItems(items) {
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }

  // Adds the given items (eg. the pot) plus the ticked add-ons in one request. If Shopify rejects the request
  // (eg. one item sold out in the meantime), each item is retried on its own so the others still get added.
  async function addWithExtras(formId, items) {
    var allItems = (items || []).concat(getItems(formId));
    if (!allItems.length) return;

    try {
      var response = await postItems(allItems);
      if (!response.ok && allItems.length > 1) {
        for (var i = 0; i < allItems.length; i++) {
          await postItems([allItems[i]]);
        }
      }
    } catch (error) {
      console.error('Error:', error);
    }

    clear(formId);
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  window.ProductAddons = { getItems: getItems, clear: clear, addWithExtras: addWithExtras };

  document.addEventListener('variant:add', function(event) {
    // The pot script handles both when it is on the page
    if (window.variantAddonsHandlesExtras) return;

    // getAttribute: on a product form, .id returns the <input name="id"> field instead of the form ID
    var formId = event.target.getAttribute('id');
    var container = getContainers(formId)[0];
    if (!container) return;

    var productAdded = event.detail.items.some(function(item) {
      return String(item.product_id) === container.dataset.productId;
    });

    if (productAdded) addWithExtras(formId, []);
  });

  // Carousel: same Swiper settings as the pot carousel. Swiper is loaded in sections/main-product.liquid.
  // The arrows are passed as elements (not class selectors) so they never mix with the pot carousel arrows.
  function initCarousels() {
    if (!window.Swiper) return;

    document.querySelectorAll('.product-addons').forEach(function(container) {
      var el = container.querySelector('.product-addons__swiper');
      if (!el || el.swiper) return;

      new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
          nextEl: container.querySelector('.product-addons__next'),
          prevEl: container.querySelector('.product-addons__prev'),
        },
      });
    });
  }

  initCarousels();
  document.addEventListener('shopify:section:load', initCarousels);
})();
